// extracted by mini-css-extract-plugin
export var dropdown = "_rq-0";
export var imageWrapper = "_rq-3";
export var itemNameContainer = "_rq-1";
export var productImage = "_rq-2";
export var spinnerWrapper = "_rq-4";